import type Select from 'react-select';
import { initial } from 'lodash';
import { ComponentProps } from 'react';
import { Theme } from 'styles/theme';

type ReactSelectStyles = ComponentProps<typeof Select>['styles'];

export const editAdminSelectStyles: ReactSelectStyles = {
  control: (styles) => ({
    ...styles,
    borderColor: 'gray',
    fontSize: '14px',
    lineHeight: '17px',
    borderRadius: '3px',
    boxShadow: 'none !important',
    color: '#222',
    margin: 0,
  }),
  multiValue: (styles) => ({
    ...styles,
    maxWidth: '95%', // #12403 Leave some space for the input bar, otherwise it will be on the next line in case of a long option
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    fontSize: '100%',
  }),
};

export const registerCompanySelectStyles = (theme: Theme): ReactSelectStyles => {
  return {
    placeholder: (baseStyles, state) => ({
      ...baseStyles,
      fontFamily: theme.fontFamilies.body,
      fontSize: `${theme.fontSizes.small}rem`,
      color: state.isDisabled ? 'rgba(156, 156, 156, 1)' : theme.colors.primaryBlack70,
      padding: '1rem 1rem 1rem 0',
      margin: 0,
    }),
    control: (baseStyles, state): any => ({
      ...baseStyles,
      boxShadow: 'none',
      fontSize: `${theme.fontSizes.small}rem`,
      border: '1px solid gray',
      borderRadius: 0,
      outline: state.isFocused ? `-webkit-focus-ring-color auto 1px;` : 'none',
      minHeight: '51px',
      paddingLeft: '1rem',
      transition: 'none',
      '&:hover': {
        borderColor: initial, // Prevent border change on hover
      },
    }),
    option: (baseStyles) => ({
      ...baseStyles,
      height: '30px',
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
    dropdownIndicator: (styles) => ({
      ...styles,
      paddingRight: '1rem',
    }),
    singleValue: (styles, state) => ({
      ...styles,
      padding: '1rem 1rem 1rem 0',
      margin: 0,
      color: state.isDisabled ? 'rgba(156, 156, 156, 1)' : 'rgba(21, 21, 21, 1)',
    }),
    multiValue: (styles) => ({
      ...styles,
      '> div:first-child': {
        fontSize: '100%',
      },
    }),
    valueContainer: (styles) => ({ ...styles, padding: 0, margin: 0 }),
    input: (styles) => ({ ...styles, padding: 0, margin: 0 }),
  };
};
